<!--分享页面更多选项菜单-->
<script lang="ts" setup>
import { computed, inject, ref, useI18n } from '#imports'
import EllipsisIcon from '@/components/icons/EllipsisIcon.vue'
import QuestionIcon from '@/components/icons/QuestionIcon.vue'
import WarningIcon from '@/components/icons/WarningIcon.vue'
import { InjectionKey, ShareStatus } from '@/types/enum'
import { ElDropdown, ElDropdownItem, ElDropdownMenu } from 'element-plus'

const { t } = useI18n()

const emit = defineEmits<{
  openReport: []
  downloadGuide: []
}>()

const share = inject<ShareRef>(InjectionKey.SHARE)

const { hoverAble = false, showCoverAboveViewport = false } = defineProps<{
  hoverAble?: boolean
  showCoverAboveViewport?: boolean
}>()

const dropdownRef = ref<InstanceType<typeof ElDropdown>>()

// 判断是否显示举报按钮
const showReportButton = computed(() => share?.value?.share_status === ShareStatus.OK && !showCoverAboveViewport)

const handleReport = () => {
  emit('openReport')
  dropdownRef.value?.handleClose()
}

const handleDownloadGuide = () => {
  emit('downloadGuide')
  dropdownRef.value?.handleClose()
}

// 暴露给父组件的方法和属性
defineExpose({
  dropdownRef,
  // 也可以直接暴露关闭方法供父组件调用
  closeDropdown: () => dropdownRef.value?.handleClose(),
})
</script>

<template>
  <ElDropdown
    ref="dropdownRef"
    trigger="click"
    placement="bottom-end"
    popper-class="more-options-popper"
    data-no-clear-select
  >
    <div class="more-options-container">
      <EllipsisIcon
        :hover-able="hoverAble"
        class="more-options-trigger"
      />
    </div>

    <!-- 只显示图标，不显示文字 -->

    <template #dropdown>
      <ElDropdownMenu>
        <ElDropdownItem
          v-if="showReportButton"
          @click="handleReport"
        >
          <div class="dropdown-item">
            <WarningIcon />
            <span class="dropdown-item-text">{{ t('report') }}</span>
          </div>
        </ElDropdownItem>
        <ElDropdownItem @click="handleDownloadGuide">
          <div class="dropdown-item">
            <QuestionIcon />
            <span class="dropdown-item-text">{{ t('download-guide-btn') }}</span>
          </div>
        </ElDropdownItem>
      </ElDropdownMenu>
    </template>
  </ElDropdown>
</template>

<style lang="less" scoped>
@import '@/assets/styles/screen.less';

.more-options-container {
  margin-left: 10px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  .pc({
    cursor: pointer;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px;
    &:hover {
      background: var(--color-active);
    }
  });

  .more-options-trigger {
    color: #666;
    transform: rotate(90deg);
  }
}

.dropdown-item {
  display: flex;
  align-items: center;
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  user-select: none;
  &-text {
    margin-left: 12px;
    // 超出显示省略号
    white-space: wrap !important;
    user-select: none;
  }
  color: var(--color-primary-text);
}
</style>

<style lang="less">
@import '@/assets/styles/screen.less';

.more-options-popper {
  min-width: 200px;
  max-width: 240px;
  margin-top: 10px;
  padding: 8px !important;
  border: 0.5px solid rgba(152, 162, 173, 0.4);
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  user-select: none;
  .mobile({
    margin-top: 0;
  });

  .el-popper__arrow {
    display: none;
  }

  .el-dropdown-menu {
    margin-left: 0 !important;
    padding: 0 !important;
    user-select: none;
  }
  li {
    color: var(--color-primary-text);
    font-size: 14px;
    user-select: none;
    &:hover,
    &:focus,
    &:active {
      background-color: var(--color-active) !important;
      border-radius: 8px;
    }
  }
  .el-dropdown-menu__item {
    line-height: 20px !important;
    padding: 12px 8px !important;
    color: var(--color-primary-text);
    user-select: none;
    &:hover,
    &:focus,
    &:active {
      background-color: var(--color-active) !important;
      border-radius: 8px;
    }
  }
}
</style>
